import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ShowMore } from '@yme/atoms/show-more';
import { setContentHeroIndent } from '@yme/components/ContentPage/components/HeroSection/redux/actions';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { HeroSectionContentPage } from '@yme/organisms/hero-section';
import { getCommonLabels, getRTL } from '@yme/selectors/common';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { DescriptionStyled } from './styled';
export function HeroSection(props) {
    const { title, subtitle, description, backgroundImage, isRemoveBottomIndent, youtubeId, startTime, } = props;
    const { isMobileView } = useWindowSize();
    const { common_showMore_button: labelShowMore, common_showLess_button: labelShowLess } = useSelector(getCommonLabels);
    const isRightToLeft = useSelector(getRTL);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setContentHeroIndent(isRemoveBottomIndent));
    }, [dispatch, isRemoveBottomIndent]);
    if (title && backgroundImage) {
        return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement("section", null,
                React.createElement(HeroSectionContentPage, { title: title, subtitle: subtitle, description: description, backgroundImage: backgroundImage, isRightToLeft: isRightToLeft, titleGridColumns: 8, youtubeId: youtubeId, startTime: startTime }),
                description && isMobileView && (React.createElement(ShowMore, { maxLinesCount: 3, labelShowLess: labelShowLess, labelShowMore: labelShowMore, textColor: colorCoreWhite1000, wrapper: DescriptionStyled, buttonColor: colorCoreWhite1000 }, description)))));
    }
    return null;
}
HeroSection.displayName = 'HeroSection_AEMComponent';
